import { paths } from '@/constants/paths';
import { Role } from '@/models/AccountEnums';

export function getRoleAction(role: string): string {
  return role.replace(/\s+/g, '');
}

const ROLE_LANDING_PATHS: Partial<Record<Role, string>> = {
  [Role.Administrator]: paths.administrator.users.index,
};

export function getRolePath(role: string): string {
  return (
    ROLE_LANDING_PATHS[role as Role] ?? `/${getRoleAction(role).toLowerCase()}`
  );
}

const ROLE_LABEL_KEYS: Record<Role, string> = {
  [Role.Administrator]: 'roleSwitch.roles.administrator',
  [Role.Firm]: 'roleSwitch.roles.firm',
  [Role.Estate]: 'roleSwitch.roles.estate',
  [Role.Advisor]: 'roleSwitch.roles.advisor',
  [Role.Investor]: 'roleSwitch.roles.investor',
  [Role.Banker]: 'roleSwitch.roles.banker',
  [Role.Owner]: 'roleSwitch.roles.owner',
  [Role.TeamMember]: 'roleSwitch.roles.teamMember',
};

export function getRoleLabelKey(role: Role): string {
  return ROLE_LABEL_KEYS[role];
}

export const SWITCHABLE_ROLES: readonly Role[] = [
  Role.Administrator,
  Role.Firm,
  Role.Advisor,
  Role.TeamMember,
];

export function getSwitchableRoles(
  roles: readonly Role[] | null | undefined,
  currentRole: Role | undefined,
): Role[] {
  return (roles ?? []).filter(
    (role) => role === currentRole || SWITCHABLE_ROLES.includes(role),
  );
}

export function shouldShowRoleList(
  roles: readonly Role[] | null | undefined,
  currentRole: Role | undefined,
): boolean {
  return !!currentRole && getSwitchableRoles(roles, currentRole).length > 1;
}

export function findAssignedRole(
  roles: readonly Role[] | null | undefined,
  roleName: string,
): Role | undefined {
  return roles?.find((role) => getRoleAction(role) === roleName);
}

export function consumeRequestedRole(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  const url = new URL(window.location.href);
  const role = url.searchParams.get('role');
  if (!role || url.searchParams.has('impersonationAction')) return undefined;

  url.searchParams.delete('role');
  window.history.replaceState(window.history.state, '', url.toString());
  return role;
}
